export const useComposable = () => {
    //* 静态属性
    const vars = { clientX: 0, clientY: 0 };

    //* 响应式属性
    const refs = {
        visible: ref<boolean>(false), //* 是否展示
        reduce: ref<boolean>(false), //* 是否缩小
    };

    //* 节点
    const nodes = {
        container: ref<HTMLDivElement>(),
        control: ref<HTMLElement>(),
    };

    //* 函数列表
    const methods = {
        //* 窗口关闭函数
        close: () => (refs.visible.value = false),
        //* 窗口激活函数
        open: (node?: HTMLDivElement) => {
            //* 数据更新
            refs.visible.value = true;
            refs.reduce.value = false;
            nextTick(() => {
                if (!node || !nodes.container.value) return;
                else {
                    //* 坐标初始化
                    const rect = node.getBoundingClientRect();
                    const width = nodes.container.value.offsetWidth;
                    const height = nodes.container.value.offsetHeight;
                    const docWidth = document.documentElement.clientWidth;
                    const docHeight = document.documentElement.clientHeight;
                    //* x轴坐标取整处理，减少因小数点导致的1px模糊的情况
                    vars.clientX = Math.floor(docWidth - rect.left - node.offsetWidth - width - 12);
                    vars.clientY = rect.top;
                    //* 边界处理
                    if (vars.clientX <= 0 && docWidth - rect.left + width + 12 < docWidth) vars.clientX = Math.floor(docWidth - rect.left + 12);
                    if (vars.clientY + height >= docHeight && rect.top - (height - node.offsetHeight) > 0) {
                        vars.clientY = rect.top - (height - node.offsetHeight);
                    }

                    //* 样式更新
                    nodes.container.value.style.top = vars.clientY + "px";
                    nodes.container.value.style.right = vars.clientX + "px";
                }
            });
        },
    };

    //* 响应事件
    const ons = {
        drag: {
            mousedown: (ev: MouseEvent) => {
                if (!nodes.container.value || nodes.control.value?.contains(ev.target as Node)) return false;
                else {
                    //* 缓存点击位置
                    const offset = { clientX: ev.clientX, clientY: ev.clientY };
                    //* 移动鼠标拖拽事件
                    document.onmousemove = (ev) => {
                        if (!nodes.container.value) return false;
                        else {
                            //* 样式更新
                            nodes.container.value.style.top = vars.clientY + (ev.clientY - offset.clientY) + "px";
                            nodes.container.value.style.right = vars.clientX - (ev.clientX - offset.clientX) + "px";
                        }
                    };

                    //* 松开鼠标事件
                    document.onmouseup = (ev) => {
                        //* 销毁全局事件
                        document.onmousemove = null;
                        document.onmouseup = null;
                        //* 保存当前拖拽后的位置
                        vars.clientX -= ev.clientX - offset.clientX;
                        vars.clientY += ev.clientY - offset.clientY;
                    };
                }
            },
        },
    };

    return { refs, nodes, methods, ons };
};
